import React from "react";
import Overview from "./Overview";
export const Password = () => {
  return (
    <Overview />
  );
};
